import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { hasModuleAccess } from '../../utils/moduleAccess';

interface Props {
  /** Permission module key (see backend/src/routes/index.ts requirePermission calls), or '' for no gate. */
  module: string;
  children: React.ReactNode;
}

/**
 * Blocks direct navigation to a route the current role has no access to.
 * The API already enforces this per-request — this just keeps the UI from
 * rendering a page shell the backend would reject every call from.
 */
const RequireModule: React.FC<Props> = ({ module, children }) => {
  const { roleAccess, user } = useAppSelector(s => s.auth);

  if (!hasModuleAccess(roleAccess, module, user?.permissions)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default RequireModule;
